import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import FloatingAssistantButton from "components/ui/FloatingAssistantButton";
import NotFound from "pages/NotFound";
import Login from './pages/login';
import Dashboard from './pages/dashboard';
import RegisterPage from './pages/register';
import HabitsPage from './pages/HabitsPage';
import FlashcardsPage from './pages/FlashcardsPage';
import KnowledgePage from './pages/KnowledgePage';
import ProgressPage from './pages/ProgressPage';
import SettingsPage from './pages/SettingsPage';
import HelpPage from './pages/HelpPage';
import TestingPage from './pages/testing';
import GettingStartedPage from './pages/GettingStartedPage';
import AIAssistantPage from './pages/AIAssistantPage';
import ProfilePage from './pages/ProfilePage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Authentication Routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<RegisterPage />} />
        
        {/* Main Application Routes */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/habits" element={<HabitsPage />} />
        <Route path="/flashcards" element={<FlashcardsPage />} />
        <Route path="/knowledge" element={<KnowledgePage />} />
        <Route path="/progress" element={<ProgressPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/testing" element={<TestingPage />} />
        <Route path="/assistant" element={<AIAssistantPage />} />
        <Route path="/getting-started" element={<GettingStartedPage />} />
        
        {/* Catch-all route */}
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      <FloatingAssistantButton />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
